export default {
  statuses: {
    GRANTED: 'granted',
    DENIED: 'denied',
    PROMPT: 'prompt',
    ALLOWED: 'allowed',
  },
  features: {
    CLIPBOARD_READ: 'clipboard-read',
    CLIPBOARD_WRITE: 'clipboard-write',
  },
  permissionDeniedReasons: {
    UNSUPPORTED_BROWSER: 'unsupported-browser',
    ACCESS_DENIED: 'access-denied',
  },
};
